import React from 'react';
import DesktopHome from './components/DesktopHome';

function App() {
  return (
    <div>
      <DesktopHome />
    </div>
  );
}

export default App;
